<template>
	<div tabindex="0" @focus="handleFocus" :class="getCardClass" v-scroll="handleScroll">
		<div class="card__container">
			<div v-if="flip" class="card__reveal">
				<button class="card__reveal-btn" @click="revealRear">
					<span class="bar bar--1"></span>
					<span class="bar bar--2"></span>
					<span class="text" v-html="_translate('ui.card.reveal')"></span>
				</button>
			</div>
			<div class="card__flex">
				<div :class="getFrontclass">
					<slot name="front"></slot>
				</div>
				<div v-if="flip" class="card__wrapper rear">
					<slot name="rear"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	export default {

		data: function() {

			return {

				reveal: false,
				scrolled: false,

			}

		},

		computed: {

			getCardClass: function() {

				var c = 'card fx';

				if ( this.$data.scrolled ) {

					c += ' fx--on';

				}

				if ( this.flip && this.$data.reveal ) {

					c += ' js-reveal';

				}

				if ( this.compressed ) {
					console.log(this.compressed);
					c += ' ' + this.compressed;
				}

				return c;

			},

			getFrontclass: function() {

				var c = 'card__wrapper front';

				if ( this.flip ) {

					c += ' folded';

				}

				return c;

			},

		},

		methods: {

			revealRear: function(e) {

				this.$data.reveal = ! this.$data.reveal;

			},

	  	handleScroll: function(e, el) {

	    	var bounding = el.getBoundingClientRect();
				if ( (window.innerHeight - bounding.top) >= (window.innerHeight/3) ) {
					this.$data.scrolled = true;
				};

	  	},

	  	handleFocus: function() {
	  		this.$data.scrolled = true;
	  	}

		},

	  props: {

	  	flip: {
	  		type: Boolean,
	  		default: false
	  	},
			compressed: {
				type: String,
				default: ''
			}

	  }

	}

</script>

<style lang="scss">

	.card {

		// border: 1px dashed $blue;

		display: flex;

		&:focus {
			outline: none;
			box-shadow: 0px 2px 5px rgba($blue, 0.22), 0px 2px 16px rgba($blue, 0.22);
		}

		&.fx {
			opacity: 0;
			transform: translate3d(0, -30px, 0);
			transition: opacity 1s ease, transform 1.2s ease;
		}

		&.fx--on {
			opacity: 1;
			transform: translate3d(0, 0, 0);
		}

		&.always {
			.card__wrapper {
				padding: 0;
			}
		}

		&.js-reveal {

			.card__reveal-btn {

				transform: rotate(45deg) scale(.85);

				&:focus {

					transform: rotate(45deg) scale(1);
					animation: cardpulse-open 1s ease infinite;

					.bar {
						background-color: $blue-dark;
					}

				}

			}

			.card__wrapper.front {
				transform: translate3d(-55%, 55%, 0) scale(0.5) rotateY(-120deg) rotateX(-120deg);
				border-radius: 0 30px 0 0;
			}

		}

		&.minor {

			.stat,
			.stat__number {

				@include typesize('small');

			}

		}

		&.alignleft {

			.card__details {

				text-align: left;

			}

		}

		&.side {

			.card__wrapper {
				display: flex;
				align-items: center;
			}

			.card__details {

				flex: 1;
				height: 100%;
				margin-left: 1.5rem;

				:last-child { margin-bottom: 0; }

			}

			.illustration {

				margin-bottom: 0;

			}

		}

		&.middle {

			.card__wrapper {
				justify-content: center;
			}

			.card__details {

				display: flex;
				justify-content: center;
				flex-direction: column;
				flex: unset;

			}

		}

		&.pair {

			h4 {
				@include typesize('large');
				color: $blue-dark;
				font-weight: 400;
				margin-bottom: 2.5em;
			}

			.card__wrapper {
				padding-top: .75rem;
			}

			.card__pair {

				@include mq('tab') {
					display: flex;
					justify-content: space-around;
					padding: 0 2rem;
				}

				.card__pair-item {

					// border: 1px solid blue;

					&:first-child {
						margin-bottom: 3rem;
					}

				}

			}

			.stat + p {
				margin-top: .5em;
			}

		}

		&.mono {

			.card__reveal-btn {

				border-color: $blue;

				.bar {

					background: $blue;

				}

			}

			.card__wrapper {

				&::before,
				&::after {
					content: none;
				}

				&.rear {
					background: $white;
				}

			}

		}

		&.medium {

			.card__wrapper {
				padding-left: 2rem;
				padding-right: 2rem;
			}

			.stat {

				@include typesize('large');

				+ p {

					margin-top: .5em;

				}

			}

			.stat__number {

				@include typesize('extra-large');

			}
			.card__details {
				width: 8rem;
			}
			.illustration {

				img {

					width: 6rem;

				}

			}

		}

		&.small {

			&.js-reveal {

				.card__reveal-btn {

					border-color: $white;

					&:focus {

						.bar {
							background-color: $blue-dark;
						}

					}

					.bar {

						background: $white;

					}

				}

			}

			.card__reveal-btn {

				border-color: $blue-dark;

				.bar {

					background: $blue-dark;

				}

			}

			.card__wrapper {

				padding: 2rem 1.5rem;

				&::before,
				&::after {
					content: none;
				}

			}

			.stat {

				@include typesize('large');

				+ p {

					margin-top: .5em;

				}

			}

			.stat__number {

				@include typesize('extra-large');

			}

			.illustration {

				img {

					width: 5rem;

				}

			}

			.rear-details {

				@include typesize('extra-small');

				.title {
					display: block;
					font-weight: 600;
				}

			}

		}

		&.v-center {

			.card__wrapper {

				display: flex;
				justify-content: center;
				align-items: center;

				> div {

					flex: 1;

				}

			}
		}

		&.details-v-center {

			.card__details {
				display: flex;
				align-items: center;
			}
		}

		&.padding-min {

			.card__wrapper {
				padding: 2rem 1.5rem;
			}
		}

		&.padding-lg {

			.card__stat {
				padding: 2rem;
			}

			.card__details {
				padding: 2rem;
			}
		}

		p {

			font-weight: 300;

			&.highlight {
				font-weight: 600;
				@include typesize('extra-small');
			}

			.highlight {
				color: $red;
				font-weight: 600;
			}

			.change {
				@include typesize('extra-small');
				font-weight: 600;
				display: block;
				margin-top: 1em;
			}

		}

		.stat {

			@include typesize('extra-large');
			font-weight: 600;
			color: $grey;
			margin: 0;

		}

		.stat--stacked {

			@include typesize('large');

			.stat__number {

				// @include typesize('display');
				display: block;

			}

		}

		.stat__number {

			@include typesize('display');
			color: $red;

		}

		.stat__device {

			@include typesize('large');
			color: $red;

		}

		.illustration {

			&.narrow {

				img {

					max-width: 100px;

					@include mq('tab') {
						max-width: none;
					}

				}

			}

		}

	}

	.card--blue {
		background: $blue-dark;
		color: $white;
		padding: 1.5rem;
		p {
			&.large,
			&.huge {
				color: $white;
			}
		}
	}

	.card__flex {

		display: flex;
		width: 100%;
		flex: auto;
	}

	.card__container {

		background: $white;
		box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08), 0px 2px 16px rgba(0, 0, 0, 0.06);
		text-align: center;

		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-direction: column;
		flex-grow: 1;
		flex-shrink: 1;
		flex-basis: auto;
		flex-wrap: wrap;

		position: relative;
		overflow: hidden;

		flex: auto;

	}

	.card__wrapper {

		width: 100%;
		background: $white;
		padding: 1.5rem;
		position: relative;
		z-index: 1;

		@include mq('tab') {
			padding: 2rem;
		}

		@include mq('lap') {
			padding: 2.5rem;
		}

		&.front {

			transition: transform .9s ease;
			overflow: hidden;
			flex: 1;

		}

		&.folded {

			transform: translate3d(0, 0, 0) scale(1) rotateY(0) rotateX(0);
			transform-origin: bottom left;
			border-radius: 0 0 0 0;

			&::before {

		    content: '';
		    width: 0;
		    height: 0;
		    border-style: solid;
		    border-width: 0 3.5rem 3.5rem 0;
		    border-color: transparent $blue-dark transparent transparent;
		    position: absolute;
		    top: 0;
		    right: 0;

			}

			&::after {

		    content: '';
		    width: 0;
		    height: 0;
		    border-style: solid;
		    border-width: 3.5rem 0 0 3.5rem;
		    border-color: transparent transparent transparent $white;
		    position: absolute;
		    top: 0;
		    right: 0;
		    box-shadow: -3px 3px 4px rgba(0, 0, 0, 0.05);

			}

		}

		&.rear {

			background: $blue-dark;
			color: $white;
			z-index: 0;

			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;

			display: flex;
			flex-direction: column;
			flex: 1 1 auto;

			justify-content: center;

			.line {

				display: block;
				margin: .75em 0;

			}

		}

		.rear-details {

			@include typesize('medium');

			&.small {
				@include typesize('extra-small');
			}

		}

		.card__details {

			&.card__details--no-stat {

 				padding-top: 1px;

			}

		}

	}

	.card__reveal {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 3;
    width: 3.5rem;
    height: 3.5rem;

	}


	.card__reveal-btn {

		font-weight: 200;
		display: block;
		z-index: 2;
		background-color: transparent;
		border: 1px solid $white;
		color: $white;
		width: 21px;
		height: 21px;
		font-size: 1.125rem;
		line-height: 1;
		text-align: center;
		padding: 0 0.25rem 0.125rem;
		vertical-align: top;
		border-radius: 50%;
		position: absolute;
		top: .4rem;
		right: .4rem;
		cursor: pointer;
		outline: none;

		transform: rotate(0) scale(.85);
		transform-origin: center;
		transition: color 0.2s ease-in-out, background-color .3s ease-in-out, transform .3s ease;

		&:hover,
		&:active {

			transform: rotate(0) scale(1);

		}

		&:focus {

			transform: rotate(0) scale(1);
			animation: cardpulse 1s ease infinite;
			background-color: $white;

			.bar { background: $blue-dark; }

		}

		.text {
			font-size: 0;
			visibility: hidden;
		}

		.bar {

			display: block;
			width: 11px;
			height: 1px;
			background: $white;
			position: absolute;
			top: 9px;
			left: 4px;

			transition: background-color .3s ease-in-out;

		}

		.bar--2 {

			height: 11px;
			width: 1px;
			top: 4px;
			left: 9px;

		}

		// .illustration {

		// 	img {
		// 		height: 6rem;
		// 	}

		// }

	}

	@keyframes cardpulse {
  	0% {transform: scale(1);}
  	50% {transform: scale(.85);}
  	100% {transform: scale(1);}
	}

	@keyframes cardpulse-open {
  	0% {transform: rotate(45deg) scale(1);}
  	50% {transform: rotate(45deg) scale(.85);}
  	100% {transform: rotate(45deg) scale(1);}
	}

</style>